import jwt_decode from "jwt-decode";
import { toasterUtils } from "utils/toaster.utils";
import { ASSET_MODELS_SCOPE, ASSET_SCOPES, MESSAGES } from "../../config/default.config";
import { store } from '../../store/index';
import { IValidateTokenPayload } from "./asset-keycloak.interface";
import { addAuthorizations } from "./asset-keycloak.slice";

const processToken = (IValidateTokenPayload : IValidateTokenPayload, refresh_token: string) =>{

    let auth_token = IValidateTokenPayload.token;

    let decoded : any = jwt_decode(auth_token);
    let resources = Object.keys(decoded.resource_access);
    if(!resources.includes(ASSET_MODELS_SCOPE)){
        toasterUtils.showError(MESSAGES.USER_UNAUTHORIZED);
    }
    for(let scope of resources ){
        if(ASSET_SCOPES.includes(scope)){
            store.dispatch(addAuthorizations(scope))
        }
    }
}

export const TokenServices = {
    processToken,
  };
  